import FormattedText from "../FormattedText/FormattedText";

type DiclaimerCompProps = {
  disclaimer: {
    info: string;
  };
};

const DisclaimerComp = ({ disclaimer }: DiclaimerCompProps) => {
  return (
    <FormattedText
      value={disclaimer.info}
      baseStyle={{ fontWeight: 400, color: "#757575", fontSize: "12px" }}
    />
  );
};

export default DisclaimerComp;
